import Sparkle from "@/assets/svg/Sparkle.svg?react";

/** A4 width (210mm) at 96dpi — matches layout studio preview pages. */
export const A4_PREVIEW_WIDTH_PX = 794;

/**
 * Empty Template Studio canvas shown before any layout is generated.
 */
export const TemplateStudioEmptyCanvas = () => (
  <div className="w-full">
    <div
      className="mx-auto flex h-[420px] w-full flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-gray-200 bg-white px-8 py-16 text-center"
      style={{ maxWidth: A4_PREVIEW_WIDTH_PX }}
    >
      <div className="flex size-8 items-center justify-center rounded-lg shadow-sm">
        <Sparkle aria-hidden className="size-3.5 shrink-0" />
      </div>
      <p className="text-sm font-medium text-gray-900">
        Nothing on the canvas yet
      </p>
      <p className="max-w-md text-xs leading-5 text-gray-500">
        Describe the briefing in the chat — for example, &ldquo;a media coverage
        briefing with 4 KPIs, a coverage-over-time chart and a top articles
        table&rdquo; — and Herald will lay it out here.
      </p>
    </div>
  </div>
);
